module.exports = __webpack_public_path__ + "img/thumbnail_RedDeer_f_normal.1bf88a9d.png";